// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avneue-no-vendor -> repli-sandbox-avneue-no-vendor -> amira-at-westly
// Generated: 2026-10-05T18:31:19.187Z
// Counts: 1 design, 14 content, 5 slot group, 0 collection binding, 3 section, 0 style

export const designOverrides = {
  "design._site.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "VALUE",
    "value": "#0095ff",
    "mappedField": null
  }
};

export const contentOverrides = {
  "apartment-sync.javascript_id": {
    "overrideType": "VALUE",
    "customValue": "asdfasdfasdf",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "110 Royyyyy",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitycardgrid.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>From resort-style pools to a spa-inspired retreat for you and your pet, every corner of Amira at Westly is designed for the way you want to live. Explore the amenities that turn ordinary days into something a little more elevated.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Newly redesigned one and two bedrooms</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into a home where thoughtful details make all the difference. Gourmet kitchens with stainless steel appliances and quartz countertops meet designer cabinetry, generous walk-in closets, and a private balcony that welcomes the Florida sun. Every finish is chosen to feel a little more elevated and a lot more like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Designed Around You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Resort-inspired living in Rocky Point</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>From sun-drenched afternoons by the sparkling pool to easy evenings around the fireside lounge, our shared spaces are built for both connection and calm. Break a sweat in the fitness center, host friends at the outdoor summer kitchen, or let your pup roam the fenced pet park. Just minutes from Westshore Plaza and Tampa International, this is Tampa Bay living at its most effortless.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Where Every Day Feels Like a Getaway</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from thoughtfully designed one and two-bedroom floor plans, each finished with modern features and luxurious touches. Cook in a gourmet kitchen complete with stainless steel appliances and quartz countertops, then step out to your private balcony or patio to soak in the Tampa sunshine. Every layout blends comfort and style to create the perfect place to call home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Amira at Westly, our community spaces are made for connection and leisure. Gather with neighbors at the inviting clubhouse, break a sweat in the state-of-the-art fitness center, or take a refreshing dip in the sparkling pool before unwinding in the relaxing spa. From the sundeck and community picnic area to the gameroom, lounge, and pet play areas, every shared space invites you to relax, socialize, and feel right at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.learn_more": {
    "overrideType": "VALUE",
    "customValue": "<p>Amira at Westly pairs newly renovated one and two-bedroom apartments with gourmet kitchens, quartz countertops, and private balconies just minutes from Tampa International Airport and the Westshore Business District. Recharge in the state-of-the-art fitness center and yoga and spin studio, unwind beside two resort-style pools, or connect with neighbors at the clubhouse and coffee bar. With a pet spa, package lockers, and quick access to the Veterans Expressway, top employers, and premier shopping, everything you need is right at your fingertips.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.romance_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Wake to Florida sunshine and coffee on your private balcony, then slip down to one of two resort-style pools for an afternoon that feels like a getaway. Here in Tampa's Town 'n' Country, newly renovated one and two-bedroom homes wrap smart luxury and everyday ease into a warm, welcoming community. This is the life you've always pictured on the Gulf Coast — and it's ready and waiting for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>At Amira at Westly, your furry companions are family. Our pet-friendly community welcomes dogs and cats with a dedicated dog park, pet play area, and a convenient pet washing station—so every member of your household can enjoy the Tampa sunshine.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitycardgrid.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Pools"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Soak up the Florida sunshine beside two sparkling resort-style pools, where every afternoon feels like a poolside escape just steps from home."
      }
    }
  },
  "amenitycardgrid.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Fitness Center & Yoga Studio"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Move your way in a state-of-the-art fitness center with a dedicated yoga and spin studio, so an energizing workout is always just an elevator ride away."
      }
    }
  },
  "amenitycardgrid.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Clubhouse & Coffee Bar"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Gather with neighbors, work remotely, or simply unwind in a welcoming clubhouse and coffee bar made for connection and quiet moments alike."
      }
    }
  },
  "amenitycardgrid.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "On-Site Pet Spa"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Pamper your best friend at our on-site pet spa, part of a truly pet-friendly community where every member of the family feels right at home."
      }
    }
  },
  "amenitycardgrid.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Bark Park & Pet Play Area"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Give your pup room to run and play in our on-site bark park and pet play area, where four-legged neighbors make fast friends and every day ends with a happy, tail-wagging welcome home."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 3
    }
  ]
};

export const styleOverrides = {};
